import cn from 'clsx'
import { buttonClassNames, Link } from '@ds/components'

import type { TTryForFreeCardProps } from './TryForFreeCard.types'
import styles from './TryForFreeCard.module.css'

export const TryForFreeCard = ({
    text,
    ctaLabel,
    ctaHref,
    variant = 'large',
    onCtaClick,
    className,
}: TTryForFreeCardProps) => (
    <div className={cn(styles.card, styles[variant], className)}>
        <p className={styles.text}>{text}</p>
        <div className={styles.ctaBox}>
            <Link
                variant="primary"
                href={ctaHref}
                className={cn(buttonClassNames({ variant: 'primary', size: 'small' }), styles.cta)}
                onClick={onCtaClick}
            >
                {ctaLabel}
            </Link>
        </div>
    </div>
)
